import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'WOWTheme',
  code: 'wow',
  colors: {
    headerBackground: '#ffc40c',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#f9f9f9',
    footerBackground: '#333',
    footerText: '#fff',
    footerBorder: 'transparent',
    progressBar: '#3957E1',
  },
  logoSize: {
    width: '138px',
    height: '40px',
  },
  baseColors: {
    link: '#c62328',
    cta: '#c62328',
    hover: '#58595b',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const WOWTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
